import moment from 'moment';
import {extendMoment} from 'moment-range';

if (!moment.range) extendMoment(moment);
